// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"308":"8f4237c4","562":"852870f0","597":"31d6cfe0","856":"8847b1cb","996":"f681e55b"}[chunkId] + ".chunk.css";
};